var _Path, _Path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

function SvgConnectingLoader(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 48 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(G, {
    stroke: props.color,
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M1 14.671l5.559 8.314 6.424-7.664M46.13 23.363l-5.557-8.314-6.427 7.664"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M40.605 15.087c1.652 8.82-4.687 17.482-13.161 19.468-5.91 1.387-11.831-.499-15.852-4.478M6.564 22.88c-2.609-9.77 3.98-19.286 13.122-21.428 6.314-1.48 12.63.77 16.64 5.315"
  }))));
}

export default SvgConnectingLoader;